import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './application/config.service.';
import { HttpNewService } from './application/http-new.service';
import {
    IContract,
    IContractResponse,
    IContractSigningResponse,
    IDogList,
    ITemplatesOutput,
} from '../interfaces/patient.interfaces';
import { LoadService } from './application/load.service';

@Injectable({ providedIn: 'root' })
export class ContractService {
    // делаем сигнальчик для передачи полученных из логина в компонент подписания документов, если они есть
    private documents = signal<IDogList[] | null>(null);
    public docs = this.documents.asReadonly();
    public contractPreviewRequired: boolean;

    private token = signal<string | null>(null);

    public constructor(
        private httpNew: HttpNewService,
        private load: LoadService,
    ) {
        this.contractPreviewRequired =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_REQUIRED_CONTRACT_PREVIEW;
    }
    /* Список договоров (не подписанных) */
    public getContractList(): Observable<Array<ITemplatesOutput>> {
        const url = '/contract/patient/list/sig';
        return this.httpNew.get<Array<ITemplatesOutput>>(url);
    }

    /* Подписать договор */
    public signContract(
        contractId: number,
        customerId?: number | null,
    ): Observable<Array<IContractSigningResponse>> {
        const url = '/contract/sig';
        return this.httpNew.get<Array<IContractSigningResponse>>(url, {
            contractId: contractId,
            customerId: customerId,
        });
    }

    /* Список подписанных договоров */
    public getContractListToPatient(): Observable<Array<IContract>> {
        const url = '/contract/patient/list';
        return this.httpNew.get<Array<IContract>>(url);
    }

    /** Получить неподписанный PDF документ как uint8array*/
    public getContractPdf(
        contractId: string,
        customerId?: number | null,
    ): Observable<IContractResponse> {
        return this.httpNew.get<IContractResponse>('/contract/preview', {
            contractId: contractId,
            customerId: customerId,
        });
    }

    /**  Получить подписанный документ PDF как uint8array*/
    public getSignedContract(
        contractId: string,
    ): Observable<IContractResponse> {
        return this.httpNew.get<IContractResponse>('/contract/patient/docpdf', {
            contractId: contractId,
        });
    }

    /**  Сохранение документов через сигнальчик*/
    public setDocuments(docs: ITemplatesOutput[]): void {
        let formattedDocs: IDogList[] = [];
        docs.forEach((doc) => {
            formattedDocs.push({
                id: doc.templateId,
                text: doc.templateName,
                mark: this.contractPreviewRequired,
                url: `/contract/preview?contractId=${doc.templateId}`,
            });
        });
        this.documents.set(formattedDocs);
    }

    public getDocuments(): IDogList[] | null {
        return this.documents();
    }
    public setToken(token: string): void {
        this.token.set(token);
    }
    public getToken(): string | null {
        return this.token();
    }
}
